// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab {
    visibility: hidden; 
    opacity: 0;
    float: left;
    transition: opacity 0.5s;
    padding: 0;
    height: 0px;
    margin-top: 0;
    margin-bottom: 0;
}

.tab.active {
    opacity: 1;
    height: auto;
    visibility: visible;
    float: none;
}

#tabContainer {
    overflow-y: scroll;
    height: 100%;
    padding: 13px;
}

.tabSpacer {
    padding: 13px;
}

.tabs {
    background-color: var(--highlightEm);
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    padding-left: 13px;
    padding-right: 13px;
    display: flex;
    flex-wrap: wrap;

}

.tabs button {
    cursor: pointer;
    background-color: var(--highlightEm);
    color: var(--calcite-color-text-inverse);
    height: 37.5px;
    border-radius: 0;
    border: 0;
    margin: 0;
    padding-left: 16px;
    padding-right: 16px;
    font-family: system-ui;
}

.tab:first-child {
    margin-top: 0;
}

.esri-sketch {
    display: flex;
}

.tab.active div calcite-button, .tab.active div calcite-input {
     margin-top: 6.5px; 
    margin-bottom: 6.5px; 
}

.tab.active div calcite-notice {
    margin-top: 13px;
    margin-bottom: 13px;
}

.tabButton.active, .tabButton:hover {
    border: 1px solid white;
}

.tabButton.active  {
    background-color: var(--highlight);
}

@media (max-width: 1100px) 
{  
    .tabs {
        padding: 0;
    }
    #tabContainer {
        padding: 5px;
    }

    
}`, "",{"version":3,"sources":["webpack://./src/css/sidebar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,UAAU;IACV,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,wCAAwC;IACxC,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;KACK,iBAAiB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;;;AAGJ","sourcesContent":[".tab {\r\n    visibility: hidden; \r\n    opacity: 0;\r\n    float: left;\r\n    transition: opacity 0.5s;\r\n    padding: 0;\r\n    height: 0px;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.tab.active {\r\n    opacity: 1;\r\n    height: auto;\r\n    visibility: visible;\r\n    float: none;\r\n}\r\n\r\n#tabContainer {\r\n    overflow-y: scroll;\r\n    height: 100%;\r\n    padding: 13px;\r\n}\r\n\r\n.tabSpacer {\r\n    padding: 13px;\r\n}\r\n\r\n.tabs {\r\n    background-color: var(--highlightEm);\r\n    border-top: 1px solid white;\r\n    border-bottom: 1px solid white;\r\n    padding-left: 13px;\r\n    padding-right: 13px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n\r\n}\r\n\r\n.tabs button {\r\n    cursor: pointer;\r\n    background-color: var(--highlightEm);\r\n    color: var(--calcite-color-text-inverse);\r\n    height: 37.5px;\r\n    border-radius: 0;\r\n    border: 0;\r\n    margin: 0;\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n    font-family: system-ui;\r\n}\r\n\r\n.tab:first-child {\r\n    margin-top: 0;\r\n}\r\n\r\n.esri-sketch {\r\n    display: flex;\r\n}\r\n\r\n.tab.active div calcite-button, .tab.active div calcite-input {\r\n     margin-top: 6.5px; \r\n    margin-bottom: 6.5px; \r\n}\r\n\r\n.tab.active div calcite-notice {\r\n    margin-top: 13px;\r\n    margin-bottom: 13px;\r\n}\r\n\r\n.tabButton.active, .tabButton:hover {\r\n    border: 1px solid white;\r\n}\r\n\r\n.tabButton.active  {\r\n    background-color: var(--highlight);\r\n}\r\n\r\n@media (max-width: 1100px) \r\n{  \r\n    .tabs {\r\n        padding: 0;\r\n    }\r\n    #tabContainer {\r\n        padding: 5px;\r\n    }\r\n\r\n    \r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
